import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "../store";
import {DeliousApiClient} from "@/_global/api_clients/DeliousApiClient";

@Module({
    name: "GenerationsStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class GenerationsStore extends VuexModule {
    // state
    private _all: Delious.Generation[] = [];

    // getter
    get all() {
        return this._all || [];
    }

    get selected() {
        // todo 世代選択可能にするとき、対応
        return this._all[0] || {};
    }

    @Action
    public async init() {
        const generations: Delious.GenerationListResponse = await DeliousApiClient.getGenerations();
        this.set(generations.list);
    }

    @Mutation
    private set(generations: Delious.Generation[]) {
        this._all = generations;
    }
}

export default getModule(GenerationsStore);
